/*----------------------------------
- HEADER SCROLL STATE
----------------------------------*/

/**
 * Whether the marketing header is in its compact, scrolled shape.
 *
 * The header sits in the document flow, so going compact makes the page 30px shorter
 * (`lg:pt-10` to `lg:pt-2.5`). Chrome's scroll anchoring answers a height change above
 * the viewport by moving `scrollY` the same distance. With a single threshold, a reader
 * resting between 28px and 58px went compact, was pulled back under the threshold, went
 * tall again, was pushed back over it, and so on: the page trembled for as long as they
 * stayed there, and no control under it ever held still long enough to be clicked.
 *
 * Two thresholds further apart than that 30px travel break the loop in both directions:
 * going compact lands no lower than 18px, which is above the release line, and going tall
 * lands no higher than 38px, which is below the compact line.
 */

/*----------------------------------
- CONSTANTS
----------------------------------*/

/** How far the header's height moves between its two shapes, in px. */
export const HEADER_COMPACT_TRAVEL_PX = 30;

/** Past this the header goes compact. Must stay above release + travel. */
export const HEADER_COMPACT_SCROLL_THRESHOLD_PX = 48;

/** At or under this the header goes tall again. Must stay below compact - travel. */
export const HEADER_RELEASE_SCROLL_THRESHOLD_PX = 8;

/*----------------------------------
- RESOLVER
----------------------------------*/

export const resolveHeaderScrolledState = (wasScrolled: boolean, scrollY: number): boolean => {
    if (scrollY > HEADER_COMPACT_SCROLL_THRESHOLD_PX) return true;
    if (scrollY <= HEADER_RELEASE_SCROLL_THRESHOLD_PX) return false;
    return wasScrolled;
};
